const PROPERTY_PROFESSIONAL = 'A professional property manager is someone who works for a property management business or runs their own property business. A real estate professional is someone who is licensed by the Real Estate Agents Authority.'

const ACCEPT_TERMS = 'I accept that the rental estimate I am providing for this property which differs from the RealESmart estimate has been carefully thought through for this property and is provided with all due care and is subject to market forces.'

export {PROPERTY_PROFESSIONAL, ACCEPT_TERMS}
